/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-06-15 17:38:33
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2024-09-27 21:37:18
 * @FilePath: \baishu_react_ui\src\Login\BsyRadioGroup\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from "react";
import { BsyUtils } from "../../utils/Utils";
import BsyImageUpload from "../BsyImageUpload";
import BsyMsgBubble from "../BsyMsgBubble";
import BsyThumbList from "../BsyThumbList";
import { BsyWidget } from "../BsyWidget";
import "./index.css";
import BsySubformBase from "../BsySubformBase";
import BsyFileUpload from "../BsyFileUpload";

class BsySubformImageUpload extends BsySubformBase {
  static defaultProps = {
    baseCls: "bsy-subform-upload",
  };

  constructor(props) {
    super({
      baseCls: "bsy-subform-upload",
      ...props,
    });

    this.element = React.createRef();
  }

  getValue = () => {
    return this.value;
  };
  setValue = (value) => {
    this.value = value;
    this.setState({
      value: value,
    });
  };

  componentDidMount() {
    super.componentDidMount();
  }

  popUpPane = () => {
    const { items, value } = this.state;
    let that = this;
    that.isChange = false;
    return (
      <BsyImageUpload
        {...that.options}
        getContext={null}
        customCls={""}
        download={false}
        thumbWidth={65}
        thumbHeight={65}
        width={"auto"}
        baseCls={"bsy-upload bsy-image-upload subform"}
        value={value}
        onGetFormData={(e) => {
          return BsyUtils.applyFunc(that, that.options.onGetFormData, [], !1);
        }}
        onStopEdit={(e) => {
          that.isChange = true;
          that.value = e;
          BsyUtils.applyFunc(that, that.props.onStopEdit, [e, null, that], !1);
          that.setState({
            value: [...e],
          });
        }}
      ></BsyImageUpload>
    );
  };

  popUpPaneClose = (e) => {
    let that = this;
    var isfnd = BsyUtils.closestClass(e.target, "fui_file_preview_v1");
    if (isfnd) {
      return;
    }
    if (!that.isChange)
      BsyUtils.applyFunc(
        that,
        that.props.onClose,
        [that.state.value, null, that],
        !1
      );
    return !1;
  };

  componentWillUnmount() {
    const { subform } = this.options;
    if (subform && this.hasFocus) {
      this.hasFocus = false;
      BsyUtils.applyFunc(
        this,
        this.options.onStopEdit,
        [this.value, null, this],
        !1
      );
    }
  }
  renderDisablePane = () => {
    let that = this;
    const { value } = this.state;
    const { preview, hasTooltip, isformdata } = this.options;
    if (BsyUtils.isObjectEmpty(value)) {
      return (
        <div
          className={"bsy_form_item_disable "}
          data-watermark={React.language("content.empty")}
        ></div>
      );
    }

    if (isformdata) {
      return (
        <div
          className={"bsy_form_item_disable "}
          data-watermark={React.language("content.empty")}
        >
          <BsyFileUpload
            {...that.options}
            download={false}
            getContext={null}
            baseCls={"bsy-upload "}
            value={value}
            enable={false}
            dataId={this.props.dataId}
            formId={this.props.formId}
            appId={this.props.appId}
            is_file_down={this.props.is_file_down}
            online_edit={this.props.online_edit}
            online_edit_record={this.props.online_edit_record}
          ></BsyFileUpload>
        </div>
      );
    }
    return (
      <div
        className={"bsy_form_item_disable "}
        data-watermark={React.language("content.empty")}
      >
        <BsyThumbList
          widget={this.options}
          dataId={this.props.dataId}
          formId={this.props.formId}
          appId={this.props.appId}
          is_file_down={this.props.is_file_down}
          customCls={"select-val"}
          hasPreview={preview}
          hasTooltip={hasTooltip}
          files={value}
        />
      </div>
    );
  };

  render() {
    const { value } = this.state;
    const {
      cssName,
      hasPreview,
      hasTooltip,
      download,
      css,
      preview,
      appId,
      formId,
      dataId,
      is_file_down,
      online_edit,
      online_edit_record,
    } = this.options;
    if (!this.isEnabled()) {
      return this.renderDisablePane();
    }

    return (
      <div
        className={cssName}
        style={css}
        ref={this.element}
        onClick={(e) => {
          this._onTriggerClick(e, 340);
        }}
      >
        <div className="select-trigger">
          <BsyThumbList
            widget={this.options}
            customCls={"select-val"}
            appId={appId}
            formId={formId}
            dataId={dataId}
            is_file_down={is_file_down}
            check_image_exif={this.options.check_image_exif}
            online_edit={online_edit}
            online_edit_record={online_edit_record}
            hasPreview={preview}
            hasTooltip={hasTooltip}
            files={value}
          />
          {download &&
          !this.options.isformdata &&
          !BsyUtils.isObjectEmpty(value) ? (
            <div
              className="download"
              onClick={(e) => {
                BsyUtils._package("", value, this.options);
                e.preventDefault();
                e.stopPropagation();
              }}
            >
              <i className="icon-vip-center-excel-import"></i>
            </div>
          ) : (
            ""
          )}

          <div
            className={
              "iconSelect " +
              (!BsyUtils.isObjectEmpty(value) ? "has-value" : "")
            }
          >
            <i className={"widget-icon icon-widget-image"}></i>
            <i
              className="widget-icon icon-dingding-guide-close"
              onClick={this.clear}
            ></i>
          </div>
        </div>
      </div>
    );
  }
}

export default BsySubformImageUpload;
